import React, { useState } from 'react'
import { Button, space, Text, Toast, useToast } from '@ticketswap/solar'
import useLocalStorage from '~/hooks/useLocalStorage'
import styled from '@emotion/styled'
import Link from 'next/link'
import { getLinkProps } from '~/utils'

const Announcement = styled.div`
  margin-bottom: ${space[16]};
`

const ButtonGroup = styled.div`
  display: grid;
  grid-gap: ${space[16]};
  grid-template-columns: 1fr 1fr;
`

const VoucherToast = ({ t }) => {
  const { notify } = useToast()
  const [notified, setNotified] = useState(false)
  const [voucherDismissed, setVoucherDismissed] = useLocalStorage(
    'voucher_dismissed',
    false
  )
  const { href, as } = getLinkProps('VOUCHERS')

  React.useEffect(() => {
    setNotified(true)

    if (false && !notified && !voucherDismissed) {
      notify(remove => {
        return (
          <Toast persist>
            <Announcement>
              <Text>{t('common:voucherToast.text')}</Text>
            </Announcement>
            <ButtonGroup>
              <Link
                href={href}
                as={`${as}?utm_source=ticketswap&utm_medium=internal&utm_campaign=Notification`}
                passHref
              >
                <Button
                  as="a"
                  onClick={() => {
                    setVoucherDismissed(true)
                    remove()
                  }}
                >
                  {t('common:voucherToast.button')}
                </Button>
              </Link>
              <Button
                variant="secondary"
                onClick={() => {
                  setVoucherDismissed(true)
                  remove()
                }}
              >
                {t('common:generic.dismiss')}
              </Button>
            </ButtonGroup>
          </Toast>
        )
      })
    }
  }, [
    notify,
    notified,
    setNotified,
    voucherDismissed,
    setVoucherDismissed,
    t,
    as,
    href,
  ])

  return null
}

export default VoucherToast
